Wee.fn.make('copyLink', {
    init: function() {
        var $btnCopy = $('ref:linkAction')[0];
        var $code = $('ref:linkCode')[0];
        var scope = this;

        $.events.on({
            'ref:linkAction': {
                click: function(e) {
                    Wee.$addClass($btnCopy, '-copied');
                    $btnCopy.innerText = 'Copied';
                    scope.copyToClipboard($code.innerHTML);
                    e.preventDefault();
                }
            }
        });
    },

    copyToClipboard: function(code) {
        var $tempInput = document.createElement('INPUT');
        var $body = document.getElementsByTagName('body')[0];

        $body.appendChild($tempInput);
        $tempInput.setAttribute('value', code);
        $tempInput.select();
        document.execCommand('copy');
        $body.removeChild($tempInput);
    }
});

Wee.copyLink.init();
